import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getCategoryList,
  getProductList,
  getProductTypeList,
} from "../../Admin/adminSlice";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
import { getCouponTypeList, getTransactionDetails } from "../cxoSlice";
import DatePicker from "../../../Component/datePicker";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const TransactionDetails = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);
  const [product, setProduct] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [paymentType, setPaymentType] = useState<any>("");
  const [transactionStatus, setTransactionStatus] = useState(2);
  const [transactionList, setTransactionList] = useState<any>([]);
  const [couponType, setCouponType] = useState<any>("");
  const [couponTypeList, setCouponTypeList] = useState<any>([]);
  const [paymentTypeList, setPaymentTypeList] = useState<any>([]);

  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
    dispatch(
      getCouponTypeList({
        callback: (res: any) => {
          setCouponTypeList(res?.data);
          const newArrr = res?.data
          const newItem = {
            _id: 5,
            name: "Without Coupon",
          };
          newArrr.unshift(newItem);
          setPaymentTypeList(newArrr);
        },
        errorCallback: () => { },
      })
    );
  }, []);

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
    const postData = {
      productTypeId: productType?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const onchangeProduct = (value: any) => {
    setProduct(value);
  };
  const onchangePaymentType = (value: any) => {
    setPaymentType(value);
  };
  const onchangeCouponType = (value: any) => {
    setCouponType(value);
  };

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };
  const getTransactionDetailsData = (val: any) => {
    setTransactionStatus(val);
    const postData = {
      startDate: startDate,
      endDate: endDate,
      productTypeId: productType?._id,
      categoryId: category?._id,
      productId: product?._id,
      paymentType: paymentType?._id,
      status: val,
      couponTypeId: couponType?._id,
    };
    if (
      postData["productTypeId"] === null ||
      postData["productTypeId"] === undefined ||
      postData["productTypeId"] === ""
    ) {
      delete postData["productTypeId"];
    }
    if (
      postData["categoryId"] === null ||
      postData["categoryId"] === undefined ||
      postData["categoryId"] === ""
    ) {
      delete postData["categoryId"];
    }
    if (
      postData["productId"] === null ||
      postData["productId"] === undefined ||
      postData["productId"] === ""
    ) {
      delete postData["productId"];
    }
    if (
      postData["paymentType"] === null ||
      postData["paymentType"] === undefined ||
      postData["paymentType"] === ""
    ) {
      delete postData["paymentType"];
    }
    if (
      postData["couponTypeId"] === null ||
      postData["couponTypeId"] === undefined ||
      postData["couponTypeId"] === ""
    ) {
      delete postData["couponTypeId"];
    }
    dispatch(
      getTransactionDetails({
        params: postData,
        callback: (res: any) => {
          setTransactionList(res?.data);
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      startDate: startDate,
      endDate: endDate,
      productTypeId: productType?._id,
      categoryId: category?._id,
      productId: product?._id,
      status: transactionStatus,
      paymentType: paymentType?._id,
      couponTypeId: couponType?._id,
    };
    if (
      postData["productTypeId"] === null ||
      postData["productTypeId"] === undefined ||
      postData["productTypeId"] === ""
    ) {
      delete postData["productTypeId"];
    }
    if (
      postData["categoryId"] === null ||
      postData["categoryId"] === undefined ||
      postData["categoryId"] === ""
    ) {
      delete postData["categoryId"];
    }
    if (
      postData["productId"] === null ||
      postData["productId"] === undefined ||
      postData["productId"] === ""
    ) {
      delete postData["productId"];
    }
    if (
      postData["paymentType"] === null ||
      postData["paymentType"] === undefined ||
      postData["paymentType"] === ""
    ) {
      delete postData["paymentType"];
    }
    if (
      postData["couponTypeId"] === null ||
      postData["couponTypeId"] === undefined ||
      postData["couponTypeId"] === ""
    ) {
      delete postData["couponTypeId"];
    }
    dispatch(
      getTransactionDetails({
        params: postData,
        callback: (res: any) => {
          setTransactionList(res?.data);
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }
    return valid;
  };

  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={transactionList ? transactionList : []}
          pagename={"TransactionDetails"}
          tableHead={[
            "S.N",
            "Name",
            "Product Type",
            "Category",
            "Product",
            "Actual Amount",
            "GST Amount",
            "Total Amount",
            "Discount",
          ]}
        />
      </div>
    );
  };
  let sum: any = 0;
  for (let i = 0; i < transactionList.length; i++) {
    sum += transactionList[i].Amount;
  }
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"TRANSACTION DETAILS"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Name"} />
                <DropdownWithClear
                  labelName={"Select Product Name "}
                  setInputText={(value: any) => onchangeProduct(value)}
                  options={productList}
                  value={product}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Payment Type"} />
                <DropdownWithClear
                  labelName={"Select Payment Type "}
                  setInputText={(value: any) => onchangePaymentType(value)}
                  options={paymentTypeList}
                  value={paymentType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Coupon Type"} />
                <DropdownWithClear
                  labelName={"Select Coupon Type"}
                  setInputText={(value: any) => onchangeCouponType(value)}
                  options={couponTypeList}
                  value={couponType}
                />
              </div>
              <div className="col-md-4 mt-3">
                <div className="col-md-4 pt-2">
                  <Submitbtn name={"Search"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="bxshadow borderRadius p-2 mb-3">
          <div className="d-flex justify-content-between p-2">
            <div>
              <button
                type="button"
                className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${transactionStatus === 2 ? "active" : "outline"}`}
                onClick={() => getTransactionDetailsData(2)}
              >
                Successful
              </button>

              <button
                type="button"
                className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${transactionStatus === 0 ? "active" : "outline"}`}
                onClick={() => getTransactionDetailsData(0)}
              >
                Pending
              </button>
              <button
                type="button"
                className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${transactionStatus === 9 ? "active" : "outline"}`}
                onClick={() => getTransactionDetailsData(9)}
              >
                Cancelled
              </button>
            </div>
            <div className="d-flex align-items-center">
              <h5>
                Total :{"\u20B9"}
                {sum}
              </h5>
            </div>
          </div>
        </div>
        <div className="bxshadow borderRadius p-1">
          <div>{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;
